// extracted by mini-css-extract-plugin
export var card = "card-view-module--card--3GDsy";
export var title = "card-view-module--title--2SXgG";
export var link = "card-view-module--link--1D_CR";
export var content = "card-view-module--content--BEbX3";
export var labelItems = "card-view-module--labelItems--1o99k";
export var fieldTitle = "card-view-module--fieldTitle--224gl";